/*
 * Registers the Recover page. Same shape as the other product pages: `PageBlueprint`,
 * `pluginId: 'app'`, `oss_apps/backstage` untouched.
 */
import { createFrontendModule, PageBlueprint } from '@backstage/frontend-plugin-api';

export const RECOVER_PATH = '/recover';

const recoverPage = PageBlueprint.make({
  name: 'stackschematic-recover',
  params: {
    path: RECOVER_PATH,
    loader: async () => {
      const { RecoverPage } = await import('./RecoverPage');
      return <RecoverPage />;
    },
  },
});

export const stackSchematicRecoverModule = createFrontendModule({
  pluginId: 'app',
  extensions: [recoverPage],
});
